
export default {
    path: 'integral',
    meta: {
      title: '积分管理'
    },
    component: () => import('@/components/parent-view'),
    name: 'integral',
    children: [
        {
            path: 'point',
            name: 'point-detail',
            meta: {
              title: '积分明细'
            },
            component: () => import('@/view/integral/point-detail/detail.vue')
        },
        {
            path: 'equip',
            name: 'point-equip',
            meta: {
              title: '积分配置'
            },
            component: () => import('@/view/integral/point-equip/index.vue')
        }
    ]
}
  


// WEBPACK FOOTER //
// ./src/router/routes/integral.js